import React from "react";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Close from "mdi-material-ui/Close";
import { styled } from "@mui/material/styles";

const Header = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(3, 4),
  justifyContent: "space-between",
  backgroundColor: theme.palette.background.default,
}));

const FormHeader = (props) => {
  const { heading, onClick } = props;
  return (
    <Header>
      <Typography variant="h6">{heading}</Typography>
      <Close fontSize="small" onClick={onClick} sx={{ cursor: "pointer" }} />
    </Header>
  );
};

export default FormHeader;
